import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAuth?: boolean;
}

/**
 * ProtectedRoute component for route protection
 * @param children - Component to render if access is allowed
 * @param requireAuth - If true, requires authentication. If false, blocks authenticated users
 */
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requireAuth = true 
}) => {
  const { isAuthenticated, isLoading } = useAuth();

  // Show nothing while loading auth state
  if (isLoading) {
    return null;
  }

  // If route requires auth and user is not authenticated, redirect to home
  if (requireAuth && !isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // If route is public-only (like login) and user is authenticated, don't redirect
  // Let the Home component handle showing Dashboard or Login
  if (!requireAuth && isAuthenticated) {
    return <>{children}</>;
  }

  return <>{children}</>;
};
